import { useState } from 'react';
import {
  ExportButton, Field, FilterBar, Header, Select, Status, Table,
  dateTime, dayLabel, money, number, op, paymentNames, pointTypeNames, queryString, today, useOpsContext, useQuery,
} from './ui.jsx';

const renderers = {
  money: (value) => (value == null ? '' : <span className={Number(value) < 0 ? 'neg' : ''}>{money(value)}</span>),
  number: (value) => (value == null ? '' : number.format(Number(value))),
  datetime: dateTime,
  status: (value) => <Status value={value} />,
  payment: (value) => paymentNames[value] || value,
  point_type: (value) => pointTypeNames[value] || value,
};
const firstOfMonth = () => `${today().slice(0, 8)}01`;

export function ReportsPage() {
  const { stores, fail } = useOpsContext();
  const [key, setKey] = useState('store-summary');
  const [from, setFrom] = useState(firstOfMonth());
  const [to, setTo] = useState(today());
  const [storeId, setStoreId] = useState('');
  const catalog = useQuery(`${op}/reports`, { realtime: false });
  const params = { from, to, store_id: storeId };
  const report = useQuery(from && to ? `${op}/reports/${key}${queryString(params)}` : null);
  const summary = useQuery(from && to ? `${op}/reports/summary${queryString(params)}` : null);
  const columns = (report.data?.columns || []).map((column) => ({
    key: column.key, label: column.label, align: ['money', 'number'].includes(column.type) ? 'right' : 'left',
    render: column.key === 'day' || column.key === 'business_date' ? dayLabel : renderers[column.type],
  }));
  const s = summary.data;

  return <main className="content-page">
    <Header eyebrow="BÁO CÁO" title="Báo cáo vận hành" description="Mọi báo cáo chỉ tổng hợp các cơ sở trong phạm vi của bạn" />
    <FilterBar>
      <Select label="Loại báo cáo" value={key} onChange={setKey} options={(catalog.rows || []).map((item) => ({ id: item.key, name: item.label }))} placeholder={null} />
      <Field label="Từ ngày" type="date" value={from} onChange={setFrom} required />
      <Field label="Đến ngày" type="date" value={to} onChange={setTo} required />
      <Select label="Cơ sở" value={storeId} onChange={setStoreId} options={stores} placeholder="Toàn phạm vi" />
      <ExportButton path={`${op}/reports/${key}${queryString({ ...params, format: 'csv' })}`} filename={`${key}_${from}_${to}.csv`} onError={fail} />
    </FilterBar>
    {s && <section className="ops-summary-grid">
      <article className="card ops-highlight"><span>Booking</span><strong>{number.format(Number(s.booking.total || 0))}</strong><small>{number.format(Number(s.booking.arrived || 0))} khách đã đến · {number.format(Number(s.booking.cancelled || 0))} hủy · {number.format(Number(s.booking.no_show || 0))} không đến</small></article>
      <article className="card ops-highlight"><span>Điểm đã đổi</span><strong>{number.format(Number(s.redemption.points_used || 0))}</strong><small>{number.format(Number(s.redemption.total || 0))} lượt đổi quà</small></article>
      <article className="card ops-highlight"><span>Cảnh báo tồn kho</span><strong>{number.format(s.stock.filter((row) => row.stock_status !== 'in_stock').length)}</strong><small>món sắp hết hoặc đã hết</small></article>
    </section>}
    <section className="card table-card">
      <h2 className="card-title">{report.data?.report.label || 'Báo cáo'}</h2>
      <Table rows={report.rows} columns={columns} loading={report.loading} error={report.error} onRetry={report.reload} rowKey={(row) => JSON.stringify(row)} empty="Không có dữ liệu trong khoảng thời gian này" />
      {report.data?.truncated && <p className="modal-note">Bảng chỉ hiển thị 5.000 dòng đầu. Hãy thu hẹp khoảng ngày hoặc chọn một cơ sở.</p>}
    </section>
  </main>;
}
